import { SnapshotConfig } from "../snapshotConfig.ts";

export function getNow(): number {
    return SnapshotConfig.deterministic ? Date.parse(SnapshotConfig.deterministicNow) : Date.now();
}
